export default "__VITE_ASSET__1xALkuX9__"